import { useState } from "react";

interface NotificationState {
  message: string;
  backgroundColor: string;
  open: boolean;
}

const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    message: "",
    backgroundColor: "",
    open: false,
  });

  const showSuccess = (message: string) => {
    setNotification({
      message,
      backgroundColor: "green",
      open: true,
    });
  };

  const showFailure = (message: string) => {
    setNotification({
      message,
      backgroundColor: "red",
      open: true,
    });
  };

  const closeNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return { notification, showSuccess, showFailure, closeNotification };
};

export default useNotification;
